import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useRequest from "hooks/useRequest";

import i18n from "i18n";
import { ProviderService } from "services/ProviderService";
import { PublicService } from "services/PublicService";

import { EventRepository } from "helpers/EventRepository";

import AdminLayout from "components/MainApp/layouts/DesktopLayout";
import Loader from "components/MainApp/atoms/Loader";
import GenericErrorModal from "components/MainApp/atoms/Modals/GenericErrorModal";

import Panel from "components/MainApp/organisms/TogglePanel";
import Toggle from "components/MainApp/atoms/Forms/Toggle";

import styles from "./ProviderDetail.module.scss";
import { capitalize } from "helpers/utils/utils_general";

const ProviderDetail = (props) => {
  const history = useHistory();
  const [deleteErrorModal, setdeleteErrorModal] = useState(false);
  const [deleteErrorMsg, setdeleteErrorMsg] = useState("");
  const {
    loading,
    beforeSubmit,
    afterSubmit,
    errors,
    dealWithError,
  } = useRequest();

  const [provider, setProvider] = useState(null);

  useEffect(() => {
    if (!props.match.params.key) return;
    const id = props.match.params.key;
    beforeSubmit();
    ProviderService.provider(id).then((provider) => {
      let countries;
      let regions;
      let states;
      let localities;

      let countriesPromises = PublicService.countries();
      let regionsPromises = PublicService.regions(provider.country);
      let statesPromises = PublicService.states(
        provider.country,
        provider.region
      );
      let citiesPromises = PublicService.cities(
        provider.country,
        provider.region,
        provider.state
      );

      Promise.all([
        countriesPromises,
        regionsPromises,
        statesPromises,
        citiesPromises,
      ]).then((responses) => {
        afterSubmit();

        countries = responses[0];
        regions = responses[1];
        states = responses[2];
        localities = responses[3];

        provider.country = countries.find((c) => c.value === provider.country);
        provider.locality = localities.find(
          (c) => c.value === provider.locality
        );
        provider.region = regions.find((c) => c.value === provider.region);
        provider.state = states.find((c) => c.value === provider.state);

        setProvider(provider);
      });
    });
  }, []);

  const deleteProvider = () => {
    beforeSubmit();
    ProviderService.deleteProvider(provider.id)
      .then((rta) => {
        history.push(`/admin/providers`);
        afterSubmit();
      })
      .catch((error) => {
        afterSubmit();
        setdeleteErrorModal(true);
        setdeleteErrorMsg(i18n.t("cant.delete.provider"));
      });
  };

  const handleChangeEnabled = (e) => {
    e.preventDefault();
    beforeSubmit();

    const data = { enabled: !provider.enabled };
    ProviderService.updateProvider(props.match.params.key, data)
      .then((provider) => {
        afterSubmit();
        setProvider(provider);
        EventRepository.notificationSend({
          label: i18n.t( provider.enabled ? "update.provider.enabled" : "update.provider.disabled"),
          type: "success",
        });
      })
      .catch((error) => {
        afterSubmit();
        dealWithError(error, "generic.error", (message, errors) => {
          analizeErrors(message, errors);
        });
      });
  };

  const analizeErrors = (message, errors = {}) => {
    if (Object.keys(errors).length === 0) {
      EventRepository.notificationSend({
        label: message,
        type: "error",
      });
    }
  };

  const headerOptions = [
    {
      icon: "icon-iconos_editar",
      name: "editar",
      handler: () => {
        history.push({
          pathname: `/admin/providers/edit/${provider.id}`,
          state: {
            type: "provider",
          },
        });
      },
      tooltip: i18n.t("provider.edit"),
    },
  ];

  const handleGoBack = () => {
    history.push(`/admin/providers`);
  };

  const content = (
    <div className={styles["provider-detail-content-wrapper"]}>
      <div className={styles["edit-provider-toggle"]}>
        <p>
          {i18n.t("provider")}{" "}
          <span>{provider?.enabled ? i18n.t("enabled").toLowerCase() : i18n.t("disabled").toLowerCase()}</span>&nbsp;
          {i18n.t("to.carry.out.operations")}.
        </p>
        <Toggle
          checked={provider && provider.enabled}
          handleChange={handleChangeEnabled}
          name="enabled"
        />
      </div>

      {provider && (
        <div className={styles["provider-detail-panels"]}>
          <Panel
            fields={provider && provider.getDescriptionPanelView()}
            title={capitalize(i18n.t("description"))}
          />
          <Panel
            fields={provider && provider.getContactPanelView()}
            title={i18n.t("contact")}
          />
        </div>
      )}
    </div>
  );
  return (
    <div className={styles["provider-detail-container"]}>
      <AdminLayout
        headerTitle={i18n.t("provider.detail")}
        headerOptions={headerOptions}
        content={content}
        navHidden={true}
        goBackFunc={handleGoBack}
      ></AdminLayout>
      <GenericErrorModal
        open={deleteErrorModal}
        handleClose={() => setdeleteErrorModal(false)}
        error={deleteErrorMsg}
      ></GenericErrorModal>

      {loading && <Loader />}
    </div>
  );
};

export default ProviderDetail;
